import { Component, OnInit } from '@angular/core';
import { BpgCommonService } from '../services/bpg-common.service';
import { DataService } from "../../bpg-common/services/data.services";
import { Router } from '@angular/router';
import { BpgEventsService } from "../../bpg-events/bpg-events.service"
import { DatePipe } from '@angular/common';
import { ConstantValues } from '../models/bpg-constants';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';

@Component({
  selector: 'app-page-title',
  templateUrl: './bpg-site-home-page.component.html',
  styleUrls: ['./bpg-site-home-page.component.css']
})
export class BpgSiteHomePageComponent implements OnInit {

  title: string;


  vision: string;
  eventDetail: string;

  eventName: string;
  eventId: string;
  hideArrow = false;
  upcomingeventsinfo: any;

  userIdDto: any;
  bpgName: string;
  bpgId: any;
  userRoleDetails: any;
  siteBpgList: any;
  loginData: any;
  successMsgShow: boolean;
  siteId: any;
  getUserSiteDetails: any = { "siteBanner": "" };
  landingData: any;
  userSiteId: string;
  onFirstRender = false;
  skipRoute = false;
  url = "";
  bpgEventList: any;
  getAllEvents: any;
  myBpgList = [];

  siteIdForCalender: any = localStorage.getItem('selectedSiteId');
  selectedBpgList: any;
  eventDetails = [];
  subscribe: any;
  confirmMsg = "Are you sure you want to withdraw from all the BPG memberships?";
  selectBpgDropDownShow: boolean;
  iconKeyList: any;
  userData: string;
  awsSiteBannerUrl: string;
  eventIdForSurvey: any;
  loginDetails: any = JSON.parse(localStorage.getItem("loginData"));
  userType: any
  timeOutError: boolean;
  timeoutErrorMessage: string = ConstantValues.timeoutErrorMessage;
  userLocationCode = "";
  eventIdForDetails: any;
  /**
   * @class BpgSiteHomePageComponent
   * @constructor
   */
  constructor(private readonly bpgCommonService: BpgCommonService,
    private readonly data: DataService,
    private readonly router: Router,
    private readonly bpgEventsService: BpgEventsService,
    private readonly datePipe: DatePipe,
    private readonly spinnerService: Ng4LoadingSpinnerService,
    
    private readonly  environment: EnvironmentConfiguration
  ) { }

  ngOnInit() {

    if (this.environment.envName === 'dev' || this.environment.envName === 'qa' || this.environment.envName === 'prod') {
              if (localStorage.getItem('loginData')=== null || localStorage.getItem('loginData')=== undefined) {


        this.router.navigate(['/log-out']);
      }
    }

    if (localStorage.getItem('logOutFlag') === "true") {
      this.router.navigate(['/log-out']);
    }
    localStorage.removeItem('searchedEventsCaledarItems');
    if (this.loginDetails !== undefined) {
      this.userType = this.loginDetails.userType.trim();
    }

    this.spinnerService.show();
    /*Navigate To Take Survey Page for Logged out User and logged in user*/
    this.eventIdForSurvey = JSON.parse(localStorage.getItem("eventIdforSurvey"));
    this.eventIdForDetails = JSON.parse(localStorage.getItem("eventIdforDetails"));


    if (this.eventIdForSurvey !== null) {
      this.router.navigate(['/take-survey/' + this.eventIdForSurvey]);
      localStorage.setItem("eventIdforSurvey", null);
    }
    if (this.eventIdForDetails !== null) {
      this.router.navigate(['/event-view-details/' + this.eventIdForDetails]);
      localStorage.setItem("eventIdForDetails", null);
    }

    else {
      sessionStorage.removeItem("MembershipData");
      this.awsSiteBannerUrl = localStorage.getItem("siteBannerBaseUrl");



      window.onload = function () {
        setTimeout(function () {
          scrollTo(0, 0);
        });
      }
    }
    this.pageOnLoadFunction();
    setTimeout(function () {
      this.spinnerService.hide();
    }.bind(this), 500)

  }

  /** For displaying the events name and description on clicking of events
   * @class BpgSiteHomePageComponent
   * @method openeventsDetails
   * @param event_id
   */
  openeventsDetails(eventid) {

    document.getElementById("event_description_div").scrollIntoView({ behavior: "smooth", block: "center" });
    for (let i = 0; i < this.upcomingeventsinfo.length; i++) {
      if (eventid === this.upcomingeventsinfo[i].eventId) {

        this.eventId = eventid;
        document.getElementById(`eventlist${i}${i}`).classList.add("hideArrow");
        this.eventName = this.upcomingeventsinfo[i].eventName;
        this.eventDetail = this.upcomingeventsinfo[i].description;
      }
      if (eventid !== this.upcomingeventsinfo[i].eventId) {
        if (i === 0) {
          document.getElementById(`eventlist${i}${i}`).classList.add("hideDiv");
        }
        document.getElementById(`eventlist${i}${i}`).classList.remove("hideArrow");
      }
    }
  }

  /** For redirecting to events calendar list view
   * @class BpgSiteHomePageComponent
   * @method viewMoreEvents
   */
  viewMoreEvents() {
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    const navigatePath = "siteHome";
    const idsAndNavigatePath = {
      'siteId': this.siteIdForCalender,
      'siteName': this.getUserSiteDetails.siteName,
      'path': navigatePath
    }
    this.data.selectedSiteIdAndPath(idsAndNavigatePath);
    this.router.navigate(['events-list-view']);
  }

  /** For displaying complete description when 'view details' is clicked
   * @class BpgSiteHomePageComponent
   * @method viewMoreEventsDetails

   */
  viewMoreEventsDetails(eventid) {
    sessionStorage.setItem(this.iconKeyList, "SITELIST");
    for (const upevent of  this.upcomingeventsinfo) {
      if (upevent.eventId === eventid) {
        this.eventDetails =upevent;
        Object.assign(this.eventDetails, { 'componentName': 'bpgSiteHomePage' });
        sessionStorage.setItem("eventDetails", JSON.stringify(this.eventDetails));
        this.router.navigate(['event-view-details']);
      }
    }
  }

  setBpgName(bpgName, bpgId) {
    this.bpgName = bpgName;
    this.bpgId = bpgId;
  }

  /** For redirecting to chapter - home page when bpg is selected
   * @class BpgSiteHomePageComponent
   * @method openBpg
   * @param bpgId
   */
  openBpg(bpgId) {
    window.scrollTo(0, 0);
    localStorage.setItem('bpgId', bpgId);
    const chapterDetailsData = {
      'siteId': this.siteIdForCalender,
      'bpgId': bpgId
    }
    this.data.setMyBpgSiteIdAndBpgId(chapterDetailsData);
    this.router.navigate(["/chapter-home"]);
  }

  /** For withdrawing membership from bpg
   * @class BpgSiteHomePageComponent
   * @method withdrawMembership
   */
  withdrawMembership() {
    this.loginData = JSON.parse(localStorage.getItem('loginData'));
    this.spinnerService.show();
    this.bpgCommonService.withdrawMemberShip(this.loginData.userId).subscribe(_data => {
      this.successMsgShow = true;
      this.spinnerService.hide();
      localStorage.removeItem('status');
      localStorage.removeItem('adminId');
      window.scrollTo(0, 0);
      setTimeout(function () {
        this.successMsgShow = false;
        window.location.reload();
      }.bind(this), 3000);

    }, err => {
      console.log(JSON.stringify(err.value.message));
      if (err.value.statusText === ConstantValues.unknownError) {
        this.timeOutError = true;
      }
    });
  }

  /** For adding 365 days to current day
   * @class BpgSiteHomePageComponent
   * @method addDays
   * @params Date, number
   */
  addDays(date: Date, days: number): Date {
    date.setDate(date.getDate() + days);
    return date;
  }

  pageOnLoadFunction() {
    this.timeOutError = false;
    this.data.selectedBpgList.subscribe(selectedBpgList => this.selectedBpgList = selectedBpgList)
    this.data.saveData('default Message');

    this.data.selectedSiteIdForSiteMenu(localStorage.getItem('selectedSiteId'));

    this.data.selectedSiteIdForSiteNavMenu.subscribe(selectedSiteIdForSiteNavMenu => {
      this.siteId = selectedSiteIdForSiteNavMenu;

      this.siteIdForCalender = this.siteId;
      this.bpgCommonService.getUserSiteDeatils(this.siteId).subscribe(data => {
        if(data!=null && data != undefined){
        this.getUserSiteDetails =  data;
        this.userLocationCode = this.getUserSiteDetails.locationCode;
        this.landingData = {
          "filter": {
            "userId": "0",
            "siteId": this.siteId
          },
          "moduleId": 0,
          "page": 0,
          "presentRole": "string",
          "searchTerm": "string",
          "size": 0,
          "sortDirection": "ASC",
          "sortProperty": "string",
          "uid": "string"
        }

        this.bpgCommonService.getMyBPGsList(this.landingData).subscribe(data => {
          this.siteBpgList = data;
          if (this.siteBpgList.length === 0) {
            this.selectBpgDropDownShow = false;
          }
          else{
            this.selectBpgDropDownShow = true;
          }
          this.bpgName = 'Select';

          const fromDate = this.datePipe.transform(new Date, ConstantValues.dateFormats.dateFormat);
          const toDate = this.datePipe.transform(this.addDays(new Date, 365), ConstantValues.dateFormats.dateFormat);

          this.landingData = {
            "filter": {
              "siteId": this.siteIdForCalender,
              "fromDate": fromDate,
              "toDate": toDate
            },
            "moduleId": 0,
            "page": 0,
            "presentRole": "",
            "searchTerm": "",
            "size": 3,
            "sortDirection": "ASC",
            "sortProperty": "event_create_date",
            "uid": ""

          }

          this.bpgEventsService.getAllEvents(this.landingData).subscribe(data => {
            if(data.content!=null){
              this.upcomingeventsinfo = (data.content) ? data.content : '';
              if (this.upcomingeventsinfo.length > 0) {
                this.eventDetail = this.upcomingeventsinfo[0].description;
                this.eventName = this.upcomingeventsinfo[0].eventName;
                this.eventId = this.upcomingeventsinfo[0].eventId;
              } else {
                this.eventDetail = '';
                this.eventName = 'No upcoming events available';
                this.eventId = '';
              }
            }
          }, err => {
            console.log(JSON.stringify(err.value.message));
            if (err.value.statusText === ConstantValues.unknownError) {
              this.timeOutError = true;
            }
          })
        })
        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        this.bpgCommonService.isSiteOrBpgCreated.next(true);
      }
      }, err => {
        console.log(JSON.stringify(err.value.message));
        if (err.value.statusText === ConstantValues.unknownError) {
          this.timeOutError = true;
        }
      });
      //}
    });
  }

}
